import axiosClient from './axiosClient';

const adminComplaintService = {
    getAll: async () => {
        const response = await axiosClient.get('/admin/complaints');
        return response.data;
    },
    getSingle: async (id) => {
        const response = await axiosClient.get(`/admin/complaints/${id}`);
        return response.data;
    },
    resolve: async (id, status) => {
        // Backend expects { status: 'resolved' | 'pending' } generally. Let's send payload
        const response = await axiosClient.patch(`/admin/complaints/${id}`, { status });
        return response.data;
    },
    notifyVendor: async (id, message) => {
        const response = await axiosClient.post(`/admin/complaints/${id}/notify-vendor`, { message });
        return response.data;
    }
};

export default adminComplaintService;
